<div class="row buffer-durations-form-items">
    <div class="col-md-9 col-xs-12">
        <label [for]="itemName" [i18n]="[{target: 'innerHTML', key: labelKey}]"></label>
    </div>

    <div class="col-md-3 col-xs-12 buffer-durations-form-items-duration">
        <span *ngIf="!writeMode">{{duration}}</span>
        <input *ngIf="durationInput !== null && writeMode" class="input" [name]="itemName" [id]="itemName" type="number" min="0"
               [(ngModel)]="duration" required (change)="durationChanged()">
        <span class="buffer-durations-form-items-duration-unit" [i18n]="[{target: 'innerHTML', key: spanLabelKey}]"></span>
    </div>
</div>
